import { render } from "./ShopeHoilday.vue?vue&type=template&id=3241d39a"
import script from "./ShopeHoilday.vue?vue&type=script&lang=js"
export * from "./ShopeHoilday.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__